import React, { useEffect, useState } from "react";
import SellerSidebar from "./common/SellerSidebar";
import { Link, useNavigate } from "react-router-dom";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import axiosClient from "../Services/Axios/axios";
import Swal from "sweetalert2";
// import ProfileSidebar from "../pages/common/ProfileSidebar";
import DateFormatter from "../pages/common/DateFormatter/DateFormatter";

function ProductList() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [products, setProducts] = useState([]);

  // Search filter
  // const filteredProducts = products.filter(
  //   (p) =>
  //     p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //     p.id.toString().includes(searchQuery)
  // );

  // const totalCounts = filteredProducts.length;
  // const totalPage = Math.max(1, Math.ceil(totalCounts / limit));
  // const indexOfLast = currentPage * limit;
  // const indexOfFirst = indexOfLast - limit;
  // const currentProducts = filteredProducts.slice(indexOfFirst, indexOfLast);

  // Handlers
  const handleEdit = (productId) => {
    navigate(`/products/edit-product`, {
      state: { productId },
    });
  };

  // const deleteProduct = async (productId) => {
  //   try {
  //     const response = await axiosClient.delete(
  //       `/products/delete/${productId}`
  //     );
  //     if (response.status === 200) {
  //       Swal.fire("Deleted!", "Your product has been deleted.", "success");
  //       getProductlistData();
  //     } else {
  //       Swal.fire(
  //         "Error!",
  //         "There was an issue deleting the product.",
  //         "error"
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error deleting product:", error);
  //   }
  // };

  const handleDelete = (productId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteProduct(productId);
      }
    });
  };

  // const getProductlistData = async () => {
  //   const productData = await axiosClient.get(
  //     `/products/list?pageNo=${currentPage}&pageSize=${limit}&search=${searchQuery}`
  //   );
  //   setProducts(productData.data.data);
  // };

  // useEffect(() => {
  //   getProductlistData();
  // }, [currentPage, limit, searchQuery]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
             <div className="bradcams">
                        <span className="bothss">
                          <Link to="">Dashboard</Link>{" "}
                          <img src="/images/brd_rowwo.png" alt="" /> Store
                          <img src="/images/brd_rowwo.png" alt="" /> Product List
                        
                        </span>
                      </div>

            <div className="row">
              {/* Sidebar */}
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              {/* Main Content */}
              <div className="col-lg-9">
                {/* Search, Filter, Add Product */}
                {products?.rows?.length > 0 && (
                  <div
                    className="d-flex justify-content-end align-items-center mb-3"
                    style={{ gap: "12px" }}
                  >
                    {/* Left: Search + Filter */}
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "8px" }}
                    >
                      <div
                        className=""
                        style={{ position: "relative", width: "250px" }}
                      >
                        <input
                          type="text"
                          className="search-input "
                          placeholder="Search"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <img
                          src="/images/search.png"
                          alt="search"
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "25px",
                            height: "24px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <button className="btn-filter">
                        <img src="/images/controls-alt.png" alt="filter" />
                      </button>
                    </div>

                    {/* Right: Add Product */}
                    <Link to={"/products/add-product"}>
                      <button
                        type="button"
                        className="btn-add-product product-list"
                      >
                        <span className="plus-circle">+</span>
                        Add Product
                      </button>
                    </Link>
                  </div>
                )}

                {/* Product Table */}
                <div className="form_boxx profilss">
                  <div className="form_arar mt-0">
                    <h5>Product List ({products?.totalElement})</h5>

                    {/* Scroll wrapper */}
                    <div style={{ overflowX: "auto" }}>
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">ID</th>
                            <th className="header-cell">Product Name</th>
                            <th className="header-cell">SKU</th>
                            <th className="header-cell">Category</th>
                            <th className="header-cell">Availability</th>
                            <th className="header-cell">Product Sold</th>
                            <th className="header-cell">Amount</th>
                            <th className="header-cell">Date</th>
                            <th className="header-cell">Status</th>
                            <th className="header-cell">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products?.rows?.length > 0 ? (
                            products?.rows?.map((p) => (
                              <tr key={p.id} className="table-row">
                                <td className="table-cell">{p.id}</td>
                                <td className="table-cell">
                                  {p.product_title}
                                </td>
                                <td className="table-cell">{p.sku}</td>
                                <td className="table-cell">
                                  {p.product_category?.name}
                                </td>
                                <td className="table-cell">{p.stock} pcs </td>
                                <td className="table-cell">{p.sold}</td>
                                <td className="table-cell">{p.price}</td>
                                <td className="table-cell">
                                  {DateFormatter(p.created_at)}
                                </td>
                                <td
                                // className={`table-cell status ${p.status
                                //   .toLowerCase()
                                //   .replace(/\s/g, "-")}`}
                                >
                                  {p.stock_availability_status === 0
                                    ? "Out of Stock"
                                    : "Available"}
                                </td>
                                <td className="table-cell action">
                                  <div
                                    className="flexx"
                                    style={{ gap: "10px" }}
                                  >
                                    <img
                                      className="action-btn edit-btn"
                                      src="/images/edit_views.png"
                                      alt="edit"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleEdit(p.id)}
                                    />
                                    <img
                                      className="action-btn delete-btn"
                                      src="/images/ic_delets.png"
                                      alt="delete"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDelete(p.id)}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="product-empty">
                                <div className="empty-title">
                                  No Products listed as of now
                                </div>
                                <Link
                                  to={
                                    "/products/add-product"
                                  }
                                >
                                  <button
                                    type="button"
                                    className="btn-add-product"
                                  >
                                    <span className="plus-circle">+</span>
                                    Add Product
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Pagination */}
                {/* <div className="pages_liststs"> */}
                <CommanPagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  limit={limit}
                  totalCounts={products?.rows?.length}
                  totalPage={products?.totalElement}
                />
                {/* </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ProductList;
